import { ListSortDirection, Sort } from "../../models/api/sort";
import { EmployeeToUserDTO, EmployeeToUserSTO } from "../../models/employees-to-users";
import { BaseApiService } from "../base/base-api.service";

export class EmployeesToUsersApiService extends BaseApiService<EmployeeToUserDTO, EmployeeToUserSTO> {
  constructor() {
    super({
      servicePath: "/EmployeesToUsers",
      loadItemsPath: "/GetEmployeesToUsers",
      saveItemsPath: "/SaveEmployeesToUsers",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "legalEntity.name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
